import { getUsignedNewsletters } from '../../shared/data-services/newsletter-service';

export async function getAllUsignedNewsletters (parameter,employeeId){
  
   const data = await getUsignedNewsletters(
                        parameter, 
                        employeeId);
   return data || [];
};
